module.exports = __webpack_public_path__ + "5de2c6dfd3fe6b20145ee2d6a78a2e13.svg";